import { render, staticRenderFns } from "./alarm-list.vue?vue&type=template&id=6f8b0990&scoped=true&"
import script from "./alarm-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./alarm-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./alarm-list.vue?vue&type=style&index=0&id=6f8b0990&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b0990",
  null
  
)

/* custom blocks */
import block0 from "./alarm-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports